<template>
  <div>
    <v-row class="mps-form-wrapper">
      <v-col
        cols="4"
        class="mps-form-label__wrapper"
      >
        <label class="mps-form-label">{{ label }}</label>
      </v-col>
      <v-col
        cols="8"
        class="mps-form-field__wrapper"
      >
        <template v-if="displayable && !inLoading && inEditMode">
          <div class="in-edit-mode">
            <select
              v-model="innerData"
              :disabled="disabled"
              class="form-select"
            >
              <option
                v-for="item in filteredItems"
                :key="item.codeId"
                :value="item.codeKey"
              >
                {{ item.codeValue | translate }}
              </option>
            </select>
          </div>
        </template>
        <template v-else>
          <div class="in-view-mode">
            <div
              class="form-textarea__fieldset"
              :style="styleObject"
            >
              <textarea
                :value="display| translate"
                class="form-textarea"
                :rows="1"
                disabled
                :placeholder="placeholder"
                :rules="rules"
                type="text"
              />
            </div>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>


<script>
    import MFormRentalcompanyCodePicker from "@/assets/plugins/mps-form/providers/MFormRentalcompanyCodePicker";

    export default {
        name: "MFormMpsRentalcompanyCodePicker",
        extends: MFormRentalcompanyCodePicker,
        mixins: [],
        computed: {
            styleObject() {
                return {
                    textAlign: this.contentAlign,
                };
            },
        },
    }
</script>